import {ApolloProvider} from '@apollo/react-hooks'
// styler
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core'
import {StylesProvider} from '@material-ui/styles'
import React from 'react'
import {ThemeProvider} from 'styled-components'
import {DataContext} from './contexts/ContextConfig'
import client from './graphql/connector'
import * as Sentry from '@sentry/browser'
import {SENTRY_ENV, SENTRY_URL, userData} from './utils/globals'
import Routes from './routes/Routes'

const theme = createMuiTheme({
  font: 'muli',
  borderColor: 'rgb(204, 204, 204)',
  palette: {
    primary: {
      main: '#055469',
    },
    secondary: {
      main: '#039be5',
    },
  },
  typography: {
    fontFamily: ['muli'],
    button: {
      textTransform: 'capitalize',
    },
  },
})

Sentry.init({
  dsn: SENTRY_URL,
  environment: SENTRY_ENV,
})

Sentry.configureScope(scope => scope.setExtra('userData', userData))

const App = () => {
  const [dataContext, setDataContext] = React.useState(null)

  return (
    <ApolloProvider client={client}>
      <StylesProvider injectFirst>
        <ThemeProvider theme={theme}>
          <MuiThemeProvider theme={theme}>
            <DataContext.Provider value={{dataContext, setDataContext}}>
              <Routes />
            </DataContext.Provider>
          </MuiThemeProvider>
        </ThemeProvider>
      </StylesProvider>
    </ApolloProvider>
  )
}

export default App
